export default __webpack_public_path__ + "static/media/Path3532.fdbd9fcc.svg";